import { isEventsEnabled } from '../constants';

// Аддон аналитики: второй, отдельный экземпляр Amplitude (общий проект LangMagic).
// Мастер-выключатель в коде: поставить false, чтобы отключить всё разом.
export const ANALYTICS_ADDON_ENABLED = true;

// Браузерный ключ Amplitude публичен по природе (виден в любом бандле).
export const ADDON_AMPLITUDE_API_KEY = 'fb09350d769d5ce0dba1a3451af5bd59';

export const ADDON_PRODUCT = 'meet';
export const ADDON_COOKIE_DOMAIN = '.langmagic.com';
export const ADDON_OFF_STORAGE_KEY = 'lm_analytics_addon';

// Выключатель сборки: ANALYTICS_ADDON=off в окружении webpack (DefinePlugin в webpack/backend/plugins.js).
export const isAddonOffByBuild = (): boolean => {
  try {
    return String(process.env.ANALYTICS_ADDON || '').trim() === 'off';
  } catch (e) {
    return false;
  }
};

// Включено только на боевом хосте (как и остальные провайдеры) и пока в localStorage
// не стоит lm_analytics_addon = 'off'.
export const isAddonEnabled = (): boolean => {
  try {
    if (!ANALYTICS_ADDON_ENABLED) return false;
    if (isAddonOffByBuild()) return false;
    if (!isEventsEnabled()) return false;
    return localStorage.getItem(ADDON_OFF_STORAGE_KEY) !== 'off';
  } catch (e) {
    return false;
  }
};
